import { useState } from "react";
import ModalElement from "../../../Common/ModalElement"
import InputElement from "../../../Common/InputElement";
import ButtonElement from "../../../Common/ButtonElement";
import { copyToClipboard, generatePassword, validateInput } from "../../../utils";
import { useApiRequest } from "../../../hooks/useApiRequest";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { appApis } from "../../../constants";

const options = [
    {
        value: "random",
        title: "Automatically generate a password",
        desc: "You will be able to view and copy the password in the next step"
    },
    {
        value: "create",
        title: "Create Password",
        desc: "You will be able to create you own password"
    }
];

const ResetPassword = ({ show, hideModal, userData }) => {
    const [pass, setPass] = useState("");
    const [selectedOption, setSelectedOption] = useState("random");
    const [showPassword, setShowPassword] = useState(false);
    const [step, setStep] = useState(1);
    const [error, setError] = useState(null);
    const { request, loading } = useApiRequest();

    const resetAction = () => {
        let passValue = "";
        if (step == 1) {
            if (selectedOption == "random") passValue = generatePassword(12);
            setPass(passValue);
            setShowPassword(false);
            setTimeout(() => setStep(2), 300);
        } else {
            passValue = pass;
            if (selectedOption == "create") {
                const msg = validateInput(passValue, "password");
                setError(msg);
                if(!msg) resetPassword(userData?.userId, passValue);
            } else  resetPassword(userData?.userId, passValue);
        }
    }

    const resetPassword = (userId, pass) => {
        request({
            url: `${appApis.getUsers}/${userId}/reset-password`,
            method: "PATCH",
            body: { password: pass },
            onSuccess: () =>{
                copyToClipboard(pass);
                setTimeout(hideModal, 1500)
            }
        })
    }

    return <ModalElement size="md" show={show} title={`Reset Password`} onHide={hideModal}>
        <div className="text-start">
            <div className="installer-personal mb-3">
                <div className="d-flex justify-content-between align-items-center me-2">
                    <h5 className="mb-2">{step > 1 ? `Changing password for ${userData?.email ?? ""}` : "Choose an option"}</h5>
                </div>
                {step == 1 ? options.map((opt) => (
                    <div key={opt.value}
                        className={`form-check d-flex align-items-start mb-3 p-3 border rounded ${selectedOption === opt.value ? "border-primary bg-light" : "border-secondary"}`}
                        style={{ cursor: "pointer" }}
                        onClick={() => setSelectedOption(opt.value)}>
                        <input
                            className="form-check-input mt-2 ms-1 me-2"
                            type="radio"
                            value={opt.value}
                            checked={selectedOption === opt.value}
                            onChange={() => setSelectedOption(opt.value)}
                        />
                        <div className="form-check-label">
                            <strong className="h6">{opt.title}</strong>
                            <p className="mb-0 text-muted small">{opt.desc}</p>
                        </div>
                    </div>
                )) : null}
                {step > 1 ? <>
                    <div>
                        <InputElement
                            type={selectedOption == "random" ? showPassword ? "text" : "password" : "text"}
                            label={"Password"}
                            name={"pass"}
                            value={pass}
                            error={error}
                            onChange={(e) => setPass(e.target.value)}
                            disable={selectedOption == "random"}
                            icon={selectedOption == "random" ? showPassword ? <BsEyeSlash size={20} onClick={() => setShowPassword(!showPassword)} /> : <BsEye size={20} onClick={() => setShowPassword(!showPassword)} /> : null}
                        />
                        <span className="mb-0 float-right text-primary" style={{ cursor: "pointer", fontSize: "14px" }} onClick={() => copyToClipboard(pass)}><strong>Copy Password</strong></span>
                    </div>
                    <div className="alert alert-info d-flex align-items-center mt-2" role="alert">
                        <AiOutlineInfoCircle size={25} className="me-2" />
                        <div>
                            <strong>Note:</strong> Password will be saved once you click on the reset button
                        </div>
                    </div>
                </> : null}
            </div>
            <div className="submit-btn text-center mb-3">
                <ButtonElement text={step == 1 ? "Next" : "Reset"} cssClass="small-radius mb-1" onClick={() => resetAction()} variant="btn-outline-primary" loading={loading} />
            </div>
        </div>
    </ModalElement>
}
export default ResetPassword;